import { SuggestionsQuery } from '#server/models';
import { trpc } from '@/data-loaders';

export const useSuggestions = (params: SuggestionsQuery) => {
  const { data, isLoading, error } = trpc.suggestions.useQuery(params, {
    enabled: !!params.searchTerms, // only run if query exists
    retry: false,
  });

  return {
    results: data,
    isLoading,
    error,
  };
};
